<template>
  <div class="d-flex align-items-center w-100" v-b-tooltip.hover :title="tooltipText">

    <div class="w-85 pr-1">
      <b-progress 
        :value="progressBarValue" 
        :variant="progressVariant" 
        style="height: 10px;"
      />
    </div>

    <div class="w-15 text-right text-nowrap">
      <span class="font-weight-bold">{{ Math.round(row.CurrentStockPercentage) }}</span>
    </div>

  </div>
</template>

<script>
import { BProgress, VBTooltip } from 'bootstrap-vue';

export default {
  components: { BProgress },
  directives: { 'b-tooltip': VBTooltip },
  props: {
    row: {
      type: Object,
      required: true,
    },
  },
  computed: {
    tooltipText() {
      const current = Number(this.row.CurrentStock || 0).toLocaleString('tr-TR');
      const capacity = Number(this.row.Capacity || 0).toLocaleString('tr-TR');
      return `Mevcut: ${current} LT / Kapasite: ${capacity} LT`;
    },
    progressVariant() {
      const p = this.row.CurrentStockPercentage;
      if (p <= this.row.CriticalStockPercentage) return 'danger';
      if (p <= this.row.MinStockPercentage) return 'warning';
      return 'success';
    },
    progressBarValue() {
        return Math.min(this.row.CurrentStockPercentage, 100);
    }
  }
};
</script>